export default __webpack_public_path__ + "bbccbc3bdc499f06e96d36897500fc60.svg";